/**
 * A faixa das cotas do contrato (`B-03`, ADR-070): só para o administrador, a partir de 80% de
 * uma cota e quando ela acaba (decisão de 16/10). Não se fecha: some quando o mês renova ou
 * quando o dono do banco amplia a cota, e a moldura relê a cada dez minutos.
 */
import type { AvisoDaCota } from "../cotas";

export function AvisoDeCota({ aviso }: { aviso: AvisoDaCota | null }) {
  if (!aviso) return null;
  const vermelho = aviso.cor === "vermelho";
  return (
    <div
      role={vermelho ? "alert" : "status"}
      className={
        vermelho
          ? "rounded-cartao border border-vermelho-borda bg-vermelho-fundo px-3 py-2 text-[12px] text-vermelho"
          : "rounded-cartao border border-amarelo-borda bg-amarelo-fundo px-3 py-2 text-[12px] text-amarelo"
      }
    >
      {aviso.frase}
    </div>
  );
}
